// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../css-loader/dist/cjs.js!./EditDialogs.responsive.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile__edit-form {
  --profile-edit-dialog-row-max-width: 34rem;
  --profile-edit-dialog-action-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff));
  --profile-edit-dialog-muted-text: var(--color-text-secondary, #4A5565);
  --profile-edit-dialog-quiet-text: var(--color-text-primary, var(--gray-700, #364153));
  --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-xxs, 0.75rem);
  --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);
  --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;
  --profile-edit-dialog-mobile-image-button-padding: 0.4125rem 0.7547rem 0.4375rem 0.8625rem;
  width: 100%;
}

.profile-edit-dialog__section,
.profile-edit-dialog__section--education {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs, 0.75rem);
}

.profile-edit {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg, 1.25rem);
}

.profile-edit-dialog__section h4 {
  margin: 0;
}

.profile-edit-dialog__section fieldset {
  width: 100%;
  margin: 0;
  display: grid;
  gap: var(--spacing-sm);
  border: 0;
  padding: 0;
  min-inline-size: 0;
}

.profile-edit-dialog__field-description {
  color: var(--profile-edit-dialog-muted-text);
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-normal, normal);
  line-height: var(--line-height-base, 1.5);
}

.profile-edit-dialog__row {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-sm);
  max-width: var(--profile-edit-dialog-row-max-width);
}

.profile-edit-dialog__row--full {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__field,
.profile-edit-dialog__field-type {
  display: block;
  margin: 0;
}

.profile-edit-dialog__field-type {
  width: 100%;
}

.profile-edit-dialog__field {
  min-width: 0;
}

.profile-edit-dialog__field--stack {
  display: grid;
}

.profile-edit-dialog__field--stack > small {
  display: block;
  width: 100%;
  text-align: right;
  justify-self: end;
}

.profile-edit-dialog__field--full {
  max-width: 100% !important;
  width: 100%;
}

.profile-edit-dialog__field--row-width {
  max-width: 34rem;
  width: 100%;
}

.profile-edit-dialog__login-message {
  margin: 0;
  font-size: var(--font-size-xs, 0.75rem);
  color: var(--red-600, #E7000B);
}

.profile-edit-dialog__section + .profile-edit-dialog__login-message {
  margin-top: var(--spacing-sm, 0.938rem);
}

.profile__edit-form--projects .profile-edit-dialog__login-message {
  margin-top: var(--spacing-sm, 0.938rem);
}

#profile-modal .modal .profile__section-header .profile__action-button,
#profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {
  min-height: auto;
  padding: var(--spacing-xxs);
  border: none;
  background: none;
  color: var(--color-primary);
  font-weight: var(--font-weight-md, 500);
}

#profile-modal .modal .profile__section-header .profile__action-button:hover,
#profile-modal .modal .profile__section-header solid-ui-button.profile__action-button:hover::part(button) {
  text-decoration: underline;
}

.profile-edit-dialog__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
}

.profile-edit-dialog__actions--edge {
  margin-left: auto;
}

.profile-edit-dialog__add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.profile-edit-dialog__input-wrap {
  position: relative;
  width: 100%;
}

.profile-edit-dialog__input--with-action {
  width: 100%;
  box-sizing: border-box;
  padding-right: 7.5rem;
}

.profile-edit-dialog__delete-icon {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
  fill: currentColor;
}

.profile-edit-dialog__delete-icon svg {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
}

solid-ui-button.profile-edit-dialog__delete-button {
  min-height: var(--min-touch-target, 44px);
  min-width: var(--min-touch-target, 44px);
  color: inherit;
  --button-background: transparent;
  --button-height-md: var(--min-touch-target, 44px);
  --button-padding-md: 0;
  --button-padding-x-sm: 0;
  --button-border-width: 0;
  --button-border-radius: var(--border-radius-base, 0.3125rem);
  --button-text: currentColor;
  --button-box-shadow: none;
  --button-hover-background: var(--profile-edit-dialog-action-hover-background);
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary, #7C4DFF);
  --button-hover-box-shadow: none;
  --button-active-box-shadow: none;
  --button-active-transform: none;
  --button-icon-size-md: var(--icon-xxs, 1rem);
  --button-icon-size-lg: var(--icon-xxs, 1rem);
}

solid-ui-button.profile-edit-dialog__delete-button:hover,
solid-ui-button.profile-edit-dialog__delete-button:focus-within {
  color: inherit;
}

.profile-edit-dialog__image-preview {
  display: grid;
  gap: var(--spacing-xs);
}

.profile-edit-dialog__image-preview-header {
  margin-bottom: var(--spacing-md, 1.25rem);
}

.profile-edit-dialog__image-preview-actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs, 0.75rem);
}

.profile-edit-dialog__image-preview-label,
.profile-edit-dialog__image-preview-description {
  margin: 0;
}

.profile-edit-dialog__image-frame {
  position: relative;
  display: inline-block;
  line-height: 0;
}

.profile-edit-dialog__image-camera-button {
  display: none;
  position: absolute;
  align-items: center;
  justify-content: center;
  right: var(--spacing-2xs, 0.625rem);
  bottom: var(--spacing-2xs, 0.625rem);
  z-index: 1;
}

solid-ui-button.profile-edit-dialog__image-camera-button {
  width: 1.25rem;
  height: 1.25rem;
  min-width: 1.25rem;
  min-height: 1.25rem;
  --button-height-md: 1.25rem;
  --button-padding-md: 0.1875rem;
  --button-icon-size-md: 0.875rem;
  --button-background: var(--color-card-bg, var(--white, #FFF));
  --button-border-width: 0;
  --button-border-radius: 0.2083rem;
  --button-box-shadow: 0 0 0.2778rem 0 rgba(0, 0, 0, 0.25);
  --button-hover-background: var(--color-card-bg, var(--white, #FFF));
  --button-hover-border: transparent;
  --button-hover-text: currentColor;
  --button-hover-box-shadow: 0 0 0.2778rem 0 rgba(0, 0, 0, 0.25);
  --button-active-box-shadow: 0 0 0.2778rem 0 rgba(0, 0, 0, 0.25);
  --button-active-transform: none;
}

.profile-edit-dialog__image-camera-button svg {
  width: 0.875rem !important;
  height: 0.875rem !important;
  display: block;
  flex-shrink: 0;
}

.profile-edit-dialog__image-camera-capture-row {
  display: flex;
  justify-content: center;
  width: 100%;
}

.profile-edit-dialog__image-camera-capture-frame {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: calc(var(--spacing-xs, 0.625rem) / 2);
  margin-bottom: var(--spacing-xs, 0.625rem);
  padding: var(--spacing-2xs, 0.625rem);
  box-sizing: border-box;
  border: 1px solid var(--color-border, var(--gray-200, #E5E7EB));
  border-radius: var(--border-radius-md, 0.5rem);
}

.profile-edit-dialog__image-camera-capture-frame[hidden] {
  display: none;
}

.profile-edit-dialog__photo-capture {
  display: block;
  width: 100%;
  --photo-capture-gap: var(--spacing-2xs, 0.625rem);
  --photo-capture-frame-max-width: 260px;
  --photo-capture-surface: transparent;
  --photo-capture-text: var(--color-text-subheading, var(--gray-900, #101828));
  --photo-capture-muted-text: var(--profile-edit-dialog-muted-text);
  --photo-capture-border: var(--color-border-button, var(--gray-300, #D1D5DC));
  --photo-capture-hover: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));
  --photo-capture-shadow: none;
  --photo-capture-trigger-background: var(--color-card-bg, var(--white, #FFF));
  --photo-capture-trigger-text: var(--color-text-subheading, var(--gray-900, #101828));
}

.profile-edit-dialog__photo-capture::part(panel) {
  width: auto;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.profile-edit-dialog__photo-capture::part(header) {
  justify-content: flex-end;
}

.profile-edit-dialog__photo-capture::part(heading),
.profile-edit-dialog__photo-capture::part(status-message),
.profile-edit-dialog__photo-capture::part(cancel-button) {
  display: none;
}

.profile-edit-dialog__photo-capture::part(close-button) {
  width: auto;
  height: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--profile-edit-dialog-muted-text);
  font-size: 1.25rem;
}

.profile-edit-dialog__photo-capture::part(close-button):hover,
.profile-edit-dialog__photo-capture::part(close-button):focus-visible {
  background: transparent;
  color: var(--color-text-subheading, var(--gray-900, #101828));
}

.profile-edit-dialog__photo-capture::part(actions) {
  justify-content: center;
  gap: var(--spacing-2xs, 0.625rem);
}

.profile-edit-dialog__photo-capture::part(capture-button),
.profile-edit-dialog__photo-capture::part(retake-button),
.profile-edit-dialog__photo-capture::part(confirm-button) {
  min-height: auto;
  padding: 0.4125rem 0.6922rem 0.4375rem 0.8rem;
  border-radius: var(--border-radius-base, 0.3125rem);
  border: 0.8px solid var(--color-border-button, var(--gray-300, #D1D5DC));
  background: var(--color-card-bg, var(--white, #FFF));
  color: var(--color-text-subheading, var(--gray-900, #101828));
  font-size: var(--font-size-xxs, 0.75rem);
  font-weight: var(--font-weight-xbold, 700);
  line-height: var(--line-height-base, 1.5);
}

.profile-edit-dialog__photo-capture::part(capture-button):hover,
.profile-edit-dialog__photo-capture::part(capture-button):focus-visible,
.profile-edit-dialog__photo-capture::part(retake-button):hover,
.profile-edit-dialog__photo-capture::part(retake-button):focus-visible,
.profile-edit-dialog__photo-capture::part(confirm-button):hover,
.profile-edit-dialog__photo-capture::part(confirm-button):focus-visible {
  background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));
  border-color: var(--color-border-button-hover, var(--gray-400, #99A1AF));
}

.profile-edit-dialog__image-upload-button::part(button),
.profile-edit-dialog__image-remove-button::part(button) {
  min-height: var(--min-touch-target, 44px);
}

.profile-edit-dialog__image-button::part(button) {
  font-size: var(--font-size-xxs, 0.75rem);
  font-weight: var(--font-weight-xbold, 700);
  line-height: var(--line-height-base, 1.5);
  border-radius: var(--border-radius-base, 0.3125rem);
  transform: none;
}

.profile-edit-dialog__image-upload-button::part(button) {
  color: var(--color-text-subheading, var(--gray-900, #101828));
  border: 0.8px solid var(--color-border-button, var(--gray-300, #D1D5DC));
  background: var(--color-card-bg, var(--white, #FFF));
  padding: 0.4125rem 0.6922rem 0.4375rem 0.8rem;
}

.profile-edit-dialog__image-remove-button::part(button) {
  color: var(--red-600, #E7000B);
  padding: 0.4125rem 0.8148rem 0.4375rem 0.8625rem;
  border: 0.8px solid transparent;
  background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));
}

#profile-modal .modal .profile-edit-dialog__image-upload-button:hover::part(button),
#profile-modal .modal .profile-edit-dialog__image-upload-button:focus-within::part(button),
#profile-modal .modal .profile-edit-dialog__image-remove-button:hover::part(button),
#profile-modal .modal .profile-edit-dialog__image-remove-button:focus-within::part(button) {
  background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6)) !important;
  border-color: var(--color-border-button-hover, var(--gray-400, #99A1AF)) !important;
}

.profile-edit-dialog__paste-button {
  position: absolute;
  white-space: nowrap;
  right: var(--spacing-2xs, 0.625rem);
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  color: var(--profile-edit-dialog-muted-text);
  min-width: 0;
  --button-height-md: 0;
  --button-padding-md: 0.25rem 0.375rem;
  --button-font-size-md: var(--font-size-xxs, 0.75rem);
  --button-font-weight: var(--font-weight-normal, 400);
  --button-background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));
  --button-border-width: 0;
  --button-border-radius: var(--border-radius-base, 0.3125rem);
  --button-text: var(--profile-edit-dialog-muted-text);
  --button-box-shadow: none;
  --button-hover-background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));
  --button-hover-text: var(--profile-edit-dialog-quiet-text);
  --button-hover-box-shadow: none;
  --button-active-box-shadow: none;
  --button-active-transform: none;
  --button-icon-size-md: 0.813rem;
  --spacing-xxs: var(--spacing-xxs, 0.3125rem);
}

.profile-edit-dialog__paste-button:hover,
.profile-edit-dialog__paste-button:focus-within {
  color: var(--profile-edit-dialog-quiet-text);
}

.profile-edit-dialog__paste-icon {
  width: 0.694rem;
  height: 0.813rem;
  fill: currentColor;
}

solid-ui-button.profile-edit-dialog__drag-handle {
  min-width: 1.75rem;
  min-height: 1.75rem;
  --button-background: transparent;
  --button-height-md: 1.75rem;
  --button-padding-md: 0;
  --button-border-width: 0;
  --button-border-radius: var(--border-radius-base, 0.3125rem);
  --button-icon-size-md: 0.813rem;
  --button-box-shadow: none;
  --button-hover-background: var(--profile-edit-dialog-action-hover-background);
  --button-hover-border: transparent;
  --button-hover-text: var(--color-primary, #7C4DFF);
  --button-hover-box-shadow: none;
  --button-active-box-shadow: none;
  --button-active-transform: none;
  cursor: grab;
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
}

solid-ui-button.profile-edit-dialog__drag-handle::part(button) {
  min-width: 1.75rem;
  min-height: 1.75rem;
}

solid-ui-button.profile-edit-dialog__drag-handle:focus-visible::part(button) {
  outline: none;
}

solid-ui-button.profile-edit-dialog__drag-handle:active {
  cursor: grabbing;
}

.profile-edit-dialog__drag-handle-icon {
  display: inline-flex;
  width: 0.813rem;
  height: 0.813rem;
}

.profile-edit-dialog__drag-handle-icon svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}

.profile-edit-dialog__row--drop-target {
  outline: 1px dashed var(--color-border-button-hover, var(--gray-400, #99A1AF));
  outline-offset: 2px;
}

.profile-edit-dialog__field input,
.profile-edit-dialog__field select,
.profile-edit-dialog__field-type input,
.profile-edit-dialog__field-type select {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--min-touch-target, 44px);
  height: var(--min-touch-target, 44px);
  border-radius: var(--border-radius-base, 0.3125rem);
  border: 1px solid var(--color-border-button-hover, var(--gray-400, #99A1AF));
  background: var(--color-card-bg, var(--white, #FFF));
  color: var(--color-text-subheading, var(--gray-900, #101828));
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-medium, 500);
  padding: var(--spacing-2xs, 0.625rem);
}

.profile-edit-dialog__field input[type='date'],
.profile-edit-dialog__field-type input[type='date'] {
  min-width: 0;
}

.profile-edit-dialog__field > solid-ui-combobox,
.profile-edit-dialog__field-type > solid-ui-combobox {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  align-self: stretch;
}

.profile-edit-dialog__field textarea,
.profile-edit-dialog__field-type textarea {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--min-touch-target, 44px);
}

.profile-edit-dialog__textarea {
  color: var(--color-text-subheading, var(--gray-900, #101828));
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-md, 500);
  line-height: var(--line-height-loose, 1.6);
  border-radius: var(--border-radius-base, 0.3125rem);
  border: var(--border-width-sm, 0.1rem) solid var(--color-border-button-hover, var(--gray-400, #99A1AF));
  background: var(--color-card-bg, var(--white, #FFF));
  min-height: 10rem !important;
  height: auto;
  resize: vertical;
}

.profile__edit-form--heading {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

/* Section-specific edit dialog overrides */

.profile-edit-dialog__bio-field-container {
  display: flex;
  width: 100%;
  max-width: var(--profile-edit-dialog-row-max-width);
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xs, 0.75rem);
  box-sizing: border-box;
  margin: 0;
}

.profile-edit-dialog__row--language {
  margin-left: 0;
}

.profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog__actions--language {
  margin-left: 0;
}

.profile-edit-dialog__row--social {
  margin-left: calc(-1 * var(--spacing-2xs, 0.625rem));
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__field--social-type {
  flex: 0 0 6rem;
  width: 6rem;
  max-width: 6rem;
}

.profile-edit-dialog__field--social-url {
  flex: 1 1 auto;
  min-width: 0;
}

.profile-edit-dialog__row--project {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__row--resume-entry-header {
  align-items: center;
  border-bottom: 1px solid var(--color-border-button-hover, var(--gray-400, #99A1AF));
}

.profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__entry-heading {
  margin: 0;
}

.profile-edit-dialog__entry-heading {
  margin: 0;
  color: var(--color-text-primary, var(--gray-700, #364153));
  font-size: var(--font-size-sm, 0.875rem);
  font-weight: var(--font-weight-md, 500);
}

.profile-edit-dialog__section--education .profile-edit-dialog__section-heading {
  margin: 0;
  color: var(--color-text-primary, var(--gray-700, #364153));
  font-size: var(--font-size-md, 1rem);
  font-weight: var(--font-weight-md, 500);
}

.profile-edit-dialog__row--resume-entry-header .profile-edit-dialog__delete-button,
solid-ui-button.profile-edit-dialog__delete-button.profile-edit-dialog__delete-button {
  min-height: var(--icon-sm, 1.8rem);
  min-width: var(--icon-sm, 1.8rem);
}

/* Force two direct children to split the row into equal columns. */
.profile-edit-dialog__row--equal > .profile-edit-dialog__field,
.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-row {
  margin-bottom: calc(var(--spacing-lg, 1.25rem) / -2);
}

.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-frame {
  margin-top: calc(var(--spacing-xs, 0.625rem) / 4);
  margin-bottom: calc(var(--spacing-xs, 0.625rem) / 2);
}

.profile__edit-form--resume .profile-edit-dialog__field,
.profile__edit-form--resume .profile-edit-dialog__field-type:not(.hidden),
.profile__edit-form--contact-info .profile-edit-dialog__field,
.profile__edit-form--contact-info .profile-edit-dialog__field-type:not(.hidden) {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-xxs, 0.3125rem);
  flex: 1 0 0;
}

.profile__edit-form--resume .profile-edit-dialog__row {
  max-width: 100%;
  width: 100%;
}

.profile__edit-form--resume .profile-edit-dialog__section fieldset > .profile-edit-dialog__field {
  max-width: 100%;
}

.profile__edit-form--resume .profile-edit-dialog__field > input,
.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-select,
.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-combobox,
.profile__edit-form--resume .profile-edit-dialog__field > textarea,
.profile__edit-form--resume .profile-edit-dialog__field-type > input,
.profile__edit-form--resume .profile-edit-dialog__field-type > solid-ui-select,
.profile__edit-form--resume .profile-edit-dialog__field-type > textarea,
.profile__edit-form--contact-info .profile-edit-dialog__field > input,
.profile__edit-form--contact-info .profile-edit-dialog__field > solid-ui-select,
.profile__edit-form--contact-info .profile-edit-dialog__field > textarea,
.profile__edit-form--contact-info .profile-edit-dialog__field-type > input,
.profile__edit-form--contact-info .profile-edit-dialog__field-type > select,
.profile__edit-form--contact-info .profile-edit-dialog__field-type > solid-ui-select,
.profile__edit-form--contact-info .profile-edit-dialog__field-type > textarea {
  align-self: stretch;
}

.profile-edit-dialog__field--resume-location {
  flex: 1 0 0;
  width: auto;
  max-width: none;
}

.profile-edit-dialog__row--resume-dates {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog__field--date-group {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog__date-pair {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  width: 100%;
}

.profile-edit-dialog__date-pair > solid-ui-select {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog__resume-date-select {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.profile-edit-dialog__resume-date-select--disabled {
  pointer-events: none;
  opacity: var(--opacity-input-disabled, 0.75);
}

.profile-edit-dialog__bio-field-container > small {
  align-self: flex-end;
  text-align: right;
}

.profile-edit-dialog--heading .profile-edit-dialog__row,
.profile-edit-dialog--heading .profile-edit-dialog__field--row-width {
  max-width: 100%;
  width: 100%;
}

.profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {
  padding-bottom: var(--spacing-md, 1.25rem);
  border-bottom: 1px solid var(--color-border-lighter, var(--slate-200, #E2E8F0));
}

.profile-edit-dialog--heading .profile-edit {
  gap: calc(var(--spacing-lg, 1.25rem) / 2);
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {
  max-width: 100%;
  width: 100%;
  gap: var(--spacing-2xs, 0.625rem);
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {
  flex: 1 1 0;
  min-width: 0;
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {
  display: block;
  width: 100%;
}

.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {
  flex: 0 0 6.4375rem;
  width: 6.4375rem;
  min-width: 6.4375rem;
  max-width: 6.4375rem;
}

.profile-edit-dialog__row--address-header {
  max-width: var(--profile-edit-dialog-row-max-width);
  align-items: flex-end;
}

.profile-edit-dialog__row--inline-end {
  justify-content: flex-end;
  max-width: 100%;
}

.profile-edit-dialog__checkbox-label {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs, 0.75rem);
  cursor: var(--profile-interactive-cursor, pointer);
}

.profile-edit-dialog__checkbox-input {
  width: var(--icon-xxs, 1rem);
  height: var(--icon-xxs, 1rem);
  margin: 0;
  flex: 0 0 auto;
  accent-color: var(--color-primary, #7C4DFF);
  cursor: var(--profile-interactive-cursor, pointer);
}

.profile-edit-dialog__checkbox-input:focus-visible {
  outline: var(--focus-indicator-width, 2px) solid var(--color-primary, #7C4DFF);
  outline-offset: 2px;
}

.profile-edit-dialog__checkbox-input:disabled {
  opacity: var(--opacity-disabled, 0.5);
}

/* The street-address row is a standalone label, so cap its width like the flex rows. */
.profile-edit-dialog__section fieldset > .profile-edit-dialog__field {
  max-width: var(--profile-edit-dialog-row-max-width);
}

.profile-edit-dialog__field-type--wide {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}

.profile-edit-dialog__field-type--contact-point {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  align-self: flex-start;
}

.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-combobox {
  min-height: var(--min-touch-target, 44px);
  height: var(--min-touch-target, 44px);
}

.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-combobox::part(input) {
  min-height: var(--min-touch-target, 44px);
  height: var(--min-touch-target, 44px);
}

/* Dedicated hook for the social account type select in SocialEditDialog. */
.profile-edit-dialog__social-account-select {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  contain: inline-size;
}

.profile-edit-dialog__resume-organization-type-select {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.profile-edit-dialog__bio-field-container textarea {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: var(--min-touch-target, 44px);
}
`, "",{"version":3,"sources":["webpack://./node_modules/profile-pane/lib/styles/EditDialogs.css"],"names":[],"mappings":"AAEA;EACE,0CAA0C;EAC1C,+GAA+G;EAC/G,sEAAsE;EACtE,qFAAqF;EACrF,kFAAkF;EAClF,iFAAiF;EACjF,kEAAkE;EAClE,0FAA0F;EAC1F,WAAW;AACb;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,wCAAwC;EACxC,cAAc;EACd,gCAAgC;EAChC,iDAAiD;EACjD,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,4DAA4D;EAC5D,2BAA2B;EAC3B,yBAAyB;EACzB,6EAA6E;EAC7E,kCAAkC;EAClC,kDAAkD;EAClD,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,+BAA+B;EAC/B,6DAA6D;EAC7D,wBAAwB;EACxB,iCAAiC;EACjC,wDAAwD;EACxD,mEAAmE;EACnE,kCAAkC;EAClC,iCAAiC;EACjC,8DAA8D;EAC9D,+DAA+D;EAC/D,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iDAAiD;EACjD,0CAA0C;EAC1C,qCAAqC;EACrC,sBAAsB;EACtB,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iDAAiD;EACjD,sCAAsC;EACtC,oCAAoC;EACpC,4EAA4E;EAC5E,iEAAiE;EACjE,4EAA4E;EAC5E,oFAAoF;EACpF,4BAA4B;EAC5B,4EAA4E;EAC5E,oFAAoF;AACtF;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;;EAGE,gBAAgB;EAChB,6CAA6C;EAC7C,mDAAmD;EACnD,wEAAwE;EACxE,oDAAoD;EACpD,6DAA6D;EAC7D,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;;;;;;EAME,yEAAyE;EACzE,wEAAwE;AAC1E;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,6DAA6D;EAC7D,wEAAwE;EACxE,oDAAoD;EACpD,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,+BAA+B;EAC/B,yEAAyE;AAC3E;;AAEA;;;;EAIE,oFAAoF;EACpF,mFAAmF;AACrF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,4CAA4C;EAC5C,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,oDAAoD;EACpD,oDAAoD;EACpD,kFAAkF;EAClF,wBAAwB;EACxB,4DAA4D;EAC5D,oDAAoD;EACpD,yBAAyB;EACzB,wFAAwF;EACxF,0DAA0D;EAC1D,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,sBAAsB;EACtB,wBAAwB;EACxB,4DAA4D;EAC5D,+BAA+B;EAC/B,yBAAyB;EACzB,6EAA6E;EAC7E,kCAAkC;EAClC,kDAAkD;EAClD,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8EAA8E;EAC9E,mBAAmB;AACrB;;AAEA;;;;EAIE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yCAAyC;EACzC,qCAAqC;EACrC,mDAAmD;EACnD,4EAA4E;EAC5E,oDAAoD;EACpD,6DAA6D;EAC7D,wCAAwC;EACxC,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,wCAAwC;EACxC,uCAAuC;EACvC,0CAA0C;EAC1C,mDAAmD;EACnD,uGAAuG;EACvG,oDAAoD;EACpD,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,2CAA2C;;AAE3C;EACE,aAAa;EACb,WAAW;EACX,mDAAmD;EACnD,UAAU;EACV,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mFAAmF;AACrF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,0DAA0D;EAC1D,wCAAwC;EACxC,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,0DAA0D;EAC1D,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;;EAEE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA,mEAAmE;AACnE;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,iDAAiD;EACjD,oDAAoD;AACtD;;AAEA;;;;EAIE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;EAcE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,+EAA+E;AACjF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;EACnD,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,kDAAkD;AACpD;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,SAAS;EACT,cAAc;EACd,2CAA2C;EAC3C,kDAAkD;AACpD;;AAEA;EACE,8EAA8E;EAC9E,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uFAAuF;AACvF;EACE,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yCAAyC;AAC3C","sourcesContent":["@import './EditDialogs.responsive.css';\n\n.profile__edit-form {\n  --profile-edit-dialog-row-max-width: 34rem;\n  --profile-edit-dialog-action-hover-background: var(--color-surface-accent-subtle, var(--lavender-300, #e6dcff));\n  --profile-edit-dialog-muted-text: var(--color-text-secondary, #4A5565);\n  --profile-edit-dialog-quiet-text: var(--color-text-primary, var(--gray-700, #364153));\n  --profile-edit-dialog-mobile-image-button-font-size: var(--font-size-xxs, 0.75rem);\n  --profile-edit-dialog-mobile-image-label-font-size: var(--font-size-sm, 0.875rem);\n  --profile-edit-dialog-mobile-image-description-font-size: 0.625rem;\n  --profile-edit-dialog-mobile-image-button-padding: 0.4125rem 0.7547rem 0.4375rem 0.8625rem;\n  width: 100%;\n}\n\n.profile-edit-dialog__section,\n.profile-edit-dialog__section--education {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs, 0.75rem);\n}\n\n.profile-edit {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg, 1.25rem);\n}\n\n.profile-edit-dialog__section h4 {\n  margin: 0;\n}\n\n.profile-edit-dialog__section fieldset {\n  width: 100%;\n  margin: 0;\n  display: grid;\n  gap: var(--spacing-sm);\n  border: 0;\n  padding: 0;\n  min-inline-size: 0;\n}\n\n.profile-edit-dialog__field-description {\n  color: var(--profile-edit-dialog-muted-text);\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-normal, normal);\n  line-height: var(--line-height-base, 1.5);\n}\n\n.profile-edit-dialog__row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-sm);\n  max-width: var(--profile-edit-dialog-row-max-width);\n}\n\n.profile-edit-dialog__row--full {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__field,\n.profile-edit-dialog__field-type {\n  display: block;\n  margin: 0;\n}\n\n.profile-edit-dialog__field-type {\n  width: 100%;\n}\n\n.profile-edit-dialog__field {\n  min-width: 0;\n}\n\n.profile-edit-dialog__field--stack {\n  display: grid;\n}\n\n.profile-edit-dialog__field--stack > small {\n  display: block;\n  width: 100%;\n  text-align: right;\n  justify-self: end;\n}\n\n.profile-edit-dialog__field--full {\n  max-width: 100% !important;\n  width: 100%;\n}\n\n.profile-edit-dialog__field--row-width {\n  max-width: 34rem;\n  width: 100%;\n}\n\n.profile-edit-dialog__login-message {\n  margin: 0;\n  font-size: var(--font-size-xs, 0.75rem);\n  color: var(--red-600, #E7000B);\n}\n\n.profile-edit-dialog__section + .profile-edit-dialog__login-message {\n  margin-top: var(--spacing-sm, 0.938rem);\n}\n\n.profile__edit-form--projects .profile-edit-dialog__login-message {\n  margin-top: var(--spacing-sm, 0.938rem);\n}\n\n#profile-modal .modal .profile__section-header .profile__action-button,\n#profile-modal .modal .profile__section-header solid-ui-button.profile__action-button::part(button) {\n  min-height: auto;\n  padding: var(--spacing-xxs);\n  border: none;\n  background: none;\n  color: var(--color-primary);\n  font-weight: var(--font-weight-md, 500);\n}\n\n#profile-modal .modal .profile__section-header .profile__action-button:hover,\n#profile-modal .modal .profile__section-header solid-ui-button.profile__action-button:hover::part(button) {\n  text-decoration: underline;\n}\n\n.profile-edit-dialog__actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 0 0 auto;\n}\n\n.profile-edit-dialog__actions--edge {\n  margin-left: auto;\n}\n\n.profile-edit-dialog__add-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profile-edit-dialog__input-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.profile-edit-dialog__input--with-action {\n  width: 100%;\n  box-sizing: border-box;\n  padding-right: 7.5rem;\n}\n\n.profile-edit-dialog__delete-icon {\n  width: var(--icon-xxs, 1rem);\n  height: var(--icon-xxs, 1rem);\n  fill: currentColor;\n}\n\n.profile-edit-dialog__delete-icon svg {\n  width: var(--icon-xxs, 1rem);\n  height: var(--icon-xxs, 1rem);\n}\n\nsolid-ui-button.profile-edit-dialog__delete-button {\n  min-height: var(--min-touch-target, 44px);\n  min-width: var(--min-touch-target, 44px);\n  color: inherit;\n  --button-background: transparent;\n  --button-height-md: var(--min-touch-target, 44px);\n  --button-padding-md: 0;\n  --button-padding-x-sm: 0;\n  --button-border-width: 0;\n  --button-border-radius: var(--border-radius-base, 0.3125rem);\n  --button-text: currentColor;\n  --button-box-shadow: none;\n  --button-hover-background: var(--profile-edit-dialog-action-hover-background);\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary, #7C4DFF);\n  --button-hover-box-shadow: none;\n  --button-active-box-shadow: none;\n  --button-active-transform: none;\n  --button-icon-size-md: var(--icon-xxs, 1rem);\n  --button-icon-size-lg: var(--icon-xxs, 1rem);\n}\n\nsolid-ui-button.profile-edit-dialog__delete-button:hover,\nsolid-ui-button.profile-edit-dialog__delete-button:focus-within {\n  color: inherit;\n}\n\n.profile-edit-dialog__image-preview {\n  display: grid;\n  gap: var(--spacing-xs);\n}\n\n.profile-edit-dialog__image-preview-header {\n  margin-bottom: var(--spacing-md, 1.25rem);\n}\n\n.profile-edit-dialog__image-preview-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs, 0.75rem);\n}\n\n.profile-edit-dialog__image-preview-label,\n.profile-edit-dialog__image-preview-description {\n  margin: 0;\n}\n\n.profile-edit-dialog__image-frame {\n  position: relative;\n  display: inline-block;\n  line-height: 0;\n}\n\n.profile-edit-dialog__image-camera-button {\n  display: none;\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  right: var(--spacing-2xs, 0.625rem);\n  bottom: var(--spacing-2xs, 0.625rem);\n  z-index: 1;\n}\n\nsolid-ui-button.profile-edit-dialog__image-camera-button {\n  width: 1.25rem;\n  height: 1.25rem;\n  min-width: 1.25rem;\n  min-height: 1.25rem;\n  --button-height-md: 1.25rem;\n  --button-padding-md: 0.1875rem;\n  --button-icon-size-md: 0.875rem;\n  --button-background: var(--color-card-bg, var(--white, #FFF));\n  --button-border-width: 0;\n  --button-border-radius: 0.2083rem;\n  --button-box-shadow: 0 0 0.2778rem 0 rgba(0, 0, 0, 0.25);\n  --button-hover-background: var(--color-card-bg, var(--white, #FFF));\n  --button-hover-border: transparent;\n  --button-hover-text: currentColor;\n  --button-hover-box-shadow: 0 0 0.2778rem 0 rgba(0, 0, 0, 0.25);\n  --button-active-box-shadow: 0 0 0.2778rem 0 rgba(0, 0, 0, 0.25);\n  --button-active-transform: none;\n}\n\n.profile-edit-dialog__image-camera-button svg {\n  width: 0.875rem !important;\n  height: 0.875rem !important;\n  display: block;\n  flex-shrink: 0;\n}\n\n.profile-edit-dialog__image-camera-capture-row {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.profile-edit-dialog__image-camera-capture-frame {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  max-width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: calc(var(--spacing-xs, 0.625rem) / 2);\n  margin-bottom: var(--spacing-xs, 0.625rem);\n  padding: var(--spacing-2xs, 0.625rem);\n  box-sizing: border-box;\n  border: 1px solid var(--color-border, var(--gray-200, #E5E7EB));\n  border-radius: var(--border-radius-md, 0.5rem);\n}\n\n.profile-edit-dialog__image-camera-capture-frame[hidden] {\n  display: none;\n}\n\n.profile-edit-dialog__photo-capture {\n  display: block;\n  width: 100%;\n  --photo-capture-gap: var(--spacing-2xs, 0.625rem);\n  --photo-capture-frame-max-width: 260px;\n  --photo-capture-surface: transparent;\n  --photo-capture-text: var(--color-text-subheading, var(--gray-900, #101828));\n  --photo-capture-muted-text: var(--profile-edit-dialog-muted-text);\n  --photo-capture-border: var(--color-border-button, var(--gray-300, #D1D5DC));\n  --photo-capture-hover: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));\n  --photo-capture-shadow: none;\n  --photo-capture-trigger-background: var(--color-card-bg, var(--white, #FFF));\n  --photo-capture-trigger-text: var(--color-text-subheading, var(--gray-900, #101828));\n}\n\n.profile-edit-dialog__photo-capture::part(panel) {\n  width: auto;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.profile-edit-dialog__photo-capture::part(header) {\n  justify-content: flex-end;\n}\n\n.profile-edit-dialog__photo-capture::part(heading),\n.profile-edit-dialog__photo-capture::part(status-message),\n.profile-edit-dialog__photo-capture::part(cancel-button) {\n  display: none;\n}\n\n.profile-edit-dialog__photo-capture::part(close-button) {\n  width: auto;\n  height: auto;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--profile-edit-dialog-muted-text);\n  font-size: 1.25rem;\n}\n\n.profile-edit-dialog__photo-capture::part(close-button):hover,\n.profile-edit-dialog__photo-capture::part(close-button):focus-visible {\n  background: transparent;\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n}\n\n.profile-edit-dialog__photo-capture::part(actions) {\n  justify-content: center;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n.profile-edit-dialog__photo-capture::part(capture-button),\n.profile-edit-dialog__photo-capture::part(retake-button),\n.profile-edit-dialog__photo-capture::part(confirm-button) {\n  min-height: auto;\n  padding: 0.4125rem 0.6922rem 0.4375rem 0.8rem;\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: 0.8px solid var(--color-border-button, var(--gray-300, #D1D5DC));\n  background: var(--color-card-bg, var(--white, #FFF));\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  font-size: var(--font-size-xxs, 0.75rem);\n  font-weight: var(--font-weight-xbold, 700);\n  line-height: var(--line-height-base, 1.5);\n}\n\n.profile-edit-dialog__photo-capture::part(capture-button):hover,\n.profile-edit-dialog__photo-capture::part(capture-button):focus-visible,\n.profile-edit-dialog__photo-capture::part(retake-button):hover,\n.profile-edit-dialog__photo-capture::part(retake-button):focus-visible,\n.profile-edit-dialog__photo-capture::part(confirm-button):hover,\n.profile-edit-dialog__photo-capture::part(confirm-button):focus-visible {\n  background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));\n  border-color: var(--color-border-button-hover, var(--gray-400, #99A1AF));\n}\n\n.profile-edit-dialog__image-upload-button::part(button),\n.profile-edit-dialog__image-remove-button::part(button) {\n  min-height: var(--min-touch-target, 44px);\n}\n\n.profile-edit-dialog__image-button::part(button) {\n  font-size: var(--font-size-xxs, 0.75rem);\n  font-weight: var(--font-weight-xbold, 700);\n  line-height: var(--line-height-base, 1.5);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  transform: none;\n}\n\n.profile-edit-dialog__image-upload-button::part(button) {\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  border: 0.8px solid var(--color-border-button, var(--gray-300, #D1D5DC));\n  background: var(--color-card-bg, var(--white, #FFF));\n  padding: 0.4125rem 0.6922rem 0.4375rem 0.8rem;\n}\n\n.profile-edit-dialog__image-remove-button::part(button) {\n  color: var(--red-600, #E7000B);\n  padding: 0.4125rem 0.8148rem 0.4375rem 0.8625rem;\n  border: 0.8px solid transparent;\n  background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));\n}\n\n#profile-modal .modal .profile-edit-dialog__image-upload-button:hover::part(button),\n#profile-modal .modal .profile-edit-dialog__image-upload-button:focus-within::part(button),\n#profile-modal .modal .profile-edit-dialog__image-remove-button:hover::part(button),\n#profile-modal .modal .profile-edit-dialog__image-remove-button:focus-within::part(button) {\n  background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6)) !important;\n  border-color: var(--color-border-button-hover, var(--gray-400, #99A1AF)) !important;\n}\n\n.profile-edit-dialog__paste-button {\n  position: absolute;\n  white-space: nowrap;\n  right: var(--spacing-2xs, 0.625rem);\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  color: var(--profile-edit-dialog-muted-text);\n  min-width: 0;\n  --button-height-md: 0;\n  --button-padding-md: 0.25rem 0.375rem;\n  --button-font-size-md: var(--font-size-xxs, 0.75rem);\n  --button-font-weight: var(--font-weight-normal, 400);\n  --button-background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));\n  --button-border-width: 0;\n  --button-border-radius: var(--border-radius-base, 0.3125rem);\n  --button-text: var(--profile-edit-dialog-muted-text);\n  --button-box-shadow: none;\n  --button-hover-background: var(--color-surface-tertiary-hover, var(--gray-100, #F3F4F6));\n  --button-hover-text: var(--profile-edit-dialog-quiet-text);\n  --button-hover-box-shadow: none;\n  --button-active-box-shadow: none;\n  --button-active-transform: none;\n  --button-icon-size-md: 0.813rem;\n  --spacing-xxs: var(--spacing-xxs, 0.3125rem);\n}\n\n.profile-edit-dialog__paste-button:hover,\n.profile-edit-dialog__paste-button:focus-within {\n  color: var(--profile-edit-dialog-quiet-text);\n}\n\n.profile-edit-dialog__paste-icon {\n  width: 0.694rem;\n  height: 0.813rem;\n  fill: currentColor;\n}\n\nsolid-ui-button.profile-edit-dialog__drag-handle {\n  min-width: 1.75rem;\n  min-height: 1.75rem;\n  --button-background: transparent;\n  --button-height-md: 1.75rem;\n  --button-padding-md: 0;\n  --button-border-width: 0;\n  --button-border-radius: var(--border-radius-base, 0.3125rem);\n  --button-icon-size-md: 0.813rem;\n  --button-box-shadow: none;\n  --button-hover-background: var(--profile-edit-dialog-action-hover-background);\n  --button-hover-border: transparent;\n  --button-hover-text: var(--color-primary, #7C4DFF);\n  --button-hover-box-shadow: none;\n  --button-active-box-shadow: none;\n  --button-active-transform: none;\n  cursor: grab;\n  touch-action: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\nsolid-ui-button.profile-edit-dialog__drag-handle::part(button) {\n  min-width: 1.75rem;\n  min-height: 1.75rem;\n}\n\nsolid-ui-button.profile-edit-dialog__drag-handle:focus-visible::part(button) {\n  outline: none;\n}\n\nsolid-ui-button.profile-edit-dialog__drag-handle:active {\n  cursor: grabbing;\n}\n\n.profile-edit-dialog__drag-handle-icon {\n  display: inline-flex;\n  width: 0.813rem;\n  height: 0.813rem;\n}\n\n.profile-edit-dialog__drag-handle-icon svg {\n  width: 100%;\n  height: 100%;\n  fill: currentColor;\n}\n\n.profile-edit-dialog__row--drop-target {\n  outline: 1px dashed var(--color-border-button-hover, var(--gray-400, #99A1AF));\n  outline-offset: 2px;\n}\n\n.profile-edit-dialog__field input,\n.profile-edit-dialog__field select,\n.profile-edit-dialog__field-type input,\n.profile-edit-dialog__field-type select {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-height: var(--min-touch-target, 44px);\n  height: var(--min-touch-target, 44px);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: 1px solid var(--color-border-button-hover, var(--gray-400, #99A1AF));\n  background: var(--color-card-bg, var(--white, #FFF));\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-medium, 500);\n  padding: var(--spacing-2xs, 0.625rem);\n}\n\n.profile-edit-dialog__field input[type='date'],\n.profile-edit-dialog__field-type input[type='date'] {\n  min-width: 0;\n}\n\n.profile-edit-dialog__field > solid-ui-combobox,\n.profile-edit-dialog__field-type > solid-ui-combobox {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  align-self: stretch;\n}\n\n.profile-edit-dialog__field textarea,\n.profile-edit-dialog__field-type textarea {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-height: var(--min-touch-target, 44px);\n}\n\n.profile-edit-dialog__textarea {\n  color: var(--color-text-subheading, var(--gray-900, #101828));\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-md, 500);\n  line-height: var(--line-height-loose, 1.6);\n  border-radius: var(--border-radius-base, 0.3125rem);\n  border: var(--border-width-sm, 0.1rem) solid var(--color-border-button-hover, var(--gray-400, #99A1AF));\n  background: var(--color-card-bg, var(--white, #FFF));\n  min-height: 10rem !important;\n  height: auto;\n  resize: vertical;\n}\n\n.profile__edit-form--heading {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n/* Section-specific edit dialog overrides */\n\n.profile-edit-dialog__bio-field-container {\n  display: flex;\n  width: 100%;\n  max-width: var(--profile-edit-dialog-row-max-width);\n  padding: 0;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-xs, 0.75rem);\n  box-sizing: border-box;\n  margin: 0;\n}\n\n.profile-edit-dialog__row--language {\n  margin-left: 0;\n}\n\n.profile-edit-dialog__row--language > .profile-edit-dialog__field--language-name {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog__actions--language {\n  margin-left: 0;\n}\n\n.profile-edit-dialog__row--social {\n  margin-left: calc(-1 * var(--spacing-2xs, 0.625rem));\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__field--social-type {\n  flex: 0 0 6rem;\n  width: 6rem;\n  max-width: 6rem;\n}\n\n.profile-edit-dialog__field--social-url {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.profile-edit-dialog__row--project {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__row--resume-entry-header {\n  align-items: center;\n  border-bottom: 1px solid var(--color-border-button-hover, var(--gray-400, #99A1AF));\n}\n\n.profile-edit-dialog__row--resume-entry-header > .profile-edit-dialog__entry-heading {\n  margin: 0;\n}\n\n.profile-edit-dialog__entry-heading {\n  margin: 0;\n  color: var(--color-text-primary, var(--gray-700, #364153));\n  font-size: var(--font-size-sm, 0.875rem);\n  font-weight: var(--font-weight-md, 500);\n}\n\n.profile-edit-dialog__section--education .profile-edit-dialog__section-heading {\n  margin: 0;\n  color: var(--color-text-primary, var(--gray-700, #364153));\n  font-size: var(--font-size-md, 1rem);\n  font-weight: var(--font-weight-md, 500);\n}\n\n.profile-edit-dialog__row--resume-entry-header .profile-edit-dialog__delete-button,\nsolid-ui-button.profile-edit-dialog__delete-button.profile-edit-dialog__delete-button {\n  min-height: var(--icon-sm, 1.8rem);\n  min-width: var(--icon-sm, 1.8rem);\n}\n\n/* Force two direct children to split the row into equal columns. */\n.profile-edit-dialog__row--equal > .profile-edit-dialog__field,\n.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-row {\n  margin-bottom: calc(var(--spacing-lg, 1.25rem) / -2);\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__image-camera-capture-frame {\n  margin-top: calc(var(--spacing-xs, 0.625rem) / 4);\n  margin-bottom: calc(var(--spacing-xs, 0.625rem) / 2);\n}\n\n.profile__edit-form--resume .profile-edit-dialog__field,\n.profile__edit-form--resume .profile-edit-dialog__field-type:not(.hidden),\n.profile__edit-form--contact-info .profile-edit-dialog__field,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type:not(.hidden) {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-xxs, 0.3125rem);\n  flex: 1 0 0;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__row {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__section fieldset > .profile-edit-dialog__field {\n  max-width: 100%;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__field > input,\n.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-select,\n.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-combobox,\n.profile__edit-form--resume .profile-edit-dialog__field > textarea,\n.profile__edit-form--resume .profile-edit-dialog__field-type > input,\n.profile__edit-form--resume .profile-edit-dialog__field-type > solid-ui-select,\n.profile__edit-form--resume .profile-edit-dialog__field-type > textarea,\n.profile__edit-form--contact-info .profile-edit-dialog__field > input,\n.profile__edit-form--contact-info .profile-edit-dialog__field > solid-ui-select,\n.profile__edit-form--contact-info .profile-edit-dialog__field > textarea,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type > input,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type > select,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type > solid-ui-select,\n.profile__edit-form--contact-info .profile-edit-dialog__field-type > textarea {\n  align-self: stretch;\n}\n\n.profile-edit-dialog__field--resume-location {\n  flex: 1 0 0;\n  width: auto;\n  max-width: none;\n}\n\n.profile-edit-dialog__row--resume-dates {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog__field--date-group {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog__date-pair {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  width: 100%;\n}\n\n.profile-edit-dialog__date-pair > solid-ui-select {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog__resume-date-select {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.profile-edit-dialog__resume-date-select--disabled {\n  pointer-events: none;\n  opacity: var(--opacity-input-disabled, 0.75);\n}\n\n.profile-edit-dialog__bio-field-container > small {\n  align-self: flex-end;\n  text-align: right;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row,\n.profile-edit-dialog--heading .profile-edit-dialog__field--row-width {\n  max-width: 100%;\n  width: 100%;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--heading-photo {\n  padding-bottom: var(--spacing-md, 1.25rem);\n  border-bottom: 1px solid var(--color-border-lighter, var(--slate-200, #E2E8F0));\n}\n\n.profile-edit-dialog--heading .profile-edit {\n  gap: calc(var(--spacing-lg, 1.25rem) / 2);\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point {\n  max-width: 100%;\n  width: 100%;\n  gap: var(--spacing-2xs, 0.625rem);\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point > .profile-edit-dialog__field > .label {\n  display: block;\n  width: 100%;\n}\n\n.profile-edit-dialog--heading .profile-edit-dialog__row--contact-point.profile-edit-dialog__row--equal > .profile-edit-dialog__field-type.profile-edit-dialog__field-type--contact-point {\n  flex: 0 0 6.4375rem;\n  width: 6.4375rem;\n  min-width: 6.4375rem;\n  max-width: 6.4375rem;\n}\n\n.profile-edit-dialog__row--address-header {\n  max-width: var(--profile-edit-dialog-row-max-width);\n  align-items: flex-end;\n}\n\n.profile-edit-dialog__row--inline-end {\n  justify-content: flex-end;\n  max-width: 100%;\n}\n\n.profile-edit-dialog__checkbox-label {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--spacing-xs, 0.75rem);\n  cursor: var(--profile-interactive-cursor, pointer);\n}\n\n.profile-edit-dialog__checkbox-input {\n  width: var(--icon-xxs, 1rem);\n  height: var(--icon-xxs, 1rem);\n  margin: 0;\n  flex: 0 0 auto;\n  accent-color: var(--color-primary, #7C4DFF);\n  cursor: var(--profile-interactive-cursor, pointer);\n}\n\n.profile-edit-dialog__checkbox-input:focus-visible {\n  outline: var(--focus-indicator-width, 2px) solid var(--color-primary, #7C4DFF);\n  outline-offset: 2px;\n}\n\n.profile-edit-dialog__checkbox-input:disabled {\n  opacity: var(--opacity-disabled, 0.5);\n}\n\n/* The street-address row is a standalone label, so cap its width like the flex rows. */\n.profile-edit-dialog__section fieldset > .profile-edit-dialog__field {\n  max-width: var(--profile-edit-dialog-row-max-width);\n}\n\n.profile-edit-dialog__field-type--wide {\n  flex: 1 1 auto;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n}\n\n.profile-edit-dialog__field-type--contact-point {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n  align-self: flex-start;\n}\n\n.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-combobox {\n  min-height: var(--min-touch-target, 44px);\n  height: var(--min-touch-target, 44px);\n}\n\n.profile__edit-form--resume .profile-edit-dialog__field > solid-ui-combobox::part(input) {\n  min-height: var(--min-touch-target, 44px);\n  height: var(--min-touch-target, 44px);\n}\n\n/* Dedicated hook for the social account type select in SocialEditDialog. */\n.profile-edit-dialog__social-account-select {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n  contain: inline-size;\n}\n\n.profile-edit-dialog__resume-organization-type-select {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.profile-edit-dialog__bio-field-container textarea {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  min-height: var(--min-touch-target, 44px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
